

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";

function Icon$Loop(Props) {
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("svg", {
              className: className,
              viewBox: "0 0 512 512",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("g", {
                  transform: "translate(0,0)"
                }, React.createElement("path", {
                      d: "M245.22 31.387c-70.06.15-134.335 31.794-168.1 90.28-5.223 9.045-8.83 18.417-12.24 28C122.157 70.996 219.372 40.6 292.07 82.57c78.822 45.506 98.658 158.253 44.405 252.223-25.855 44.782-63.857 77.026-105.15 93.723 95.38 29.26 195.698-.307 240.96-78.704 54.027-93.574 8.905-220.773-100.055-283.68-40.858-23.59-84.976-34.837-127.01-34.747zm-24.763 49.945c-40.357.123-84.108 16.545-122.254 49.408C19.45 198.588-6.02 311.192 41.32 382.244c4.577 6.87 9.9 12.55 15.434 18.137C20.79 331.21 31.144 244.728 83.69 199.46c56.97-49.083 141.443-31.06 188.98 40.292 22.654 34.003 32.705 73.913 30.926 111.78 51.07-67.13 63.006-155.83 23.347-215.356h-.002C302.534 99.54 263.42 81.2 220.458 81.332zm-63.36 107.71c-26.76.083-53.228 9.95-73.05 29.65-48.848 48.55-47.855 142.19 1.144 205.94 49 63.75 128.323 76.074 177.17 27.524-47.107 29.645-84.88 26.3-128.778-20.916-39.45-42.43-24.435-122.8 24.62-171.554 23.376-23.234 51.128-35.812 77.675-37.696-21.48-22.033-50.296-33.034-78.78-32.947z",
                      fillOpacity: "1"
                    })));
}

var Loop = {
  make: Icon$Loop
};

function Icon$Goose(Props) {
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("svg", {
              className: className,
              viewBox: "0 0 512 512",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("g", {
                  transform: "translate(0,0)"
                }, React.createElement("path", {
                      d: "M370.019 18.023c-2.843-.035-5.859.197-9.075.73-81.664 13.54-38.657 142.295-36.095 217.397-84.163-16.327-168.007 121.048-289.118 152.787 58.086 52.473 206.05 89.6 331.739 11.85 39.804-24.622 45.26-92.014 34.343-165.049-6.703-44.845-71.755-133.176-10.269-141.266l.611-.504c12.884-10.608 16.606-23.842 22.522-37.699l1.699-3.976c-11.688-16.016-23.17-33.986-46.357-34.27zm5.08 19.625a9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9zm52.703 34.172c-3.28 8.167-7.411 17.45-14.612 26.293 21.035 7.63 41.929 3.078 63.079-.863-15.515-9.272-32.003-18.195-48.467-25.43zm-89.608 181.053c19.109 25.924 21.374 53.965 11.637 78.183-9.737 24.219-30.345 44.797-55.67 60.49-50.65 31.389-121.288 44.45-170.553 17.11l8.735-15.738c40.364 22.4 106.342 11.833 152.338-16.67 22.997-14.252 40.72-32.684 48.449-51.906 7.729-19.223 6.596-39.053-9.426-60.79l14.49-10.68zM273.28 456.322a332.68 332.68 0 0 1-19.095 3.232l-3.508 16.426h-13.084l3.508-14.842a400.208 400.208 0 0 1-18.852 1.506l-7.408 31.336h95.79v-18h-41.548l4.197-19.658z",
                      fill: "#fff",
                      fillOpacity: "1"
                    })));
}

var Goose = {
  make: Icon$Goose
};

function Icon$Airplane(Props) {
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("svg", {
              className: className,
              viewBox: "0 0 512 512",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("g", {
                  transform: "translate(0,0)"
                }, React.createElement("path", {
                      d: "M468 26.25c-.8-.02-1.7-.02-2.6.02v-.01c-7.2.28-16.2 2.74-25.5 6.7-18.4 7.91-37.7 21.75-48 31.99L137.4 340.8l10.5 10.5 38.9-38.8 12.8 12.8-38.8 38.9 10.5 10.5 275.8-254.6c10.2-10.3 24.1-29.61 32-48.05 3.9-9.23 6.4-18.25 6.7-25.44.2-7.19-1.3-12.01-4.9-15.55-3.1-3.09-7.1-4.66-12.9-4.81zM167.7 53.16l-14.9 16.47 43 14.36 1.4-1.23c0-.61-.3-1.79-1.1-3.55-1.9-3.97-6-9.47-10.7-14.21-4.7-4.73-10.2-8.81-14.2-10.7-1.7-.83-2.9-1.04-3.5-1.14zm240.4 5.48l34 11.31 11.3 33.95-11.3 11.3-45.3-45.25 11.3-11.31zM90.3 67.77c-8.08.35-17.37 4.63-27.48 12.21C55.09 85.78 47 93.45 38.8 101.5l201.8 100.8 59.6-64.6L90.3 67.77zm143.4 9.85l-13.2 14.6 42.6 14.18c-.1-.6-.4-1.5-1-2.7-1.8-3.99-5.9-9.49-10.7-14.23-4.7-4.73-10.2-8.81-14.2-10.7-1.7-.83-2.9-1.05-3.5-1.15zM374.3 211.8l-64.7 59.7 100.9 201.8c8.1-8.2 15.8-16.4 21.6-24.1 7.5-10.1 11.8-19.4 12.2-27.4l-70-210zm31.3 37.1l14.2 42.6 14.6-13.2c0-.6-.3-1.7-1.1-3.5-1.9-4-6-9.5-10.7-14.2-4.8-4.7-10.3-8.8-14.3-10.7-1.1-.5-2-.8-2.7-1zm23.7 65.9l-1.3 1.4 14.4 43 16.4-14.8c0-.6-.3-1.8-1.1-3.5-1.9-4-6-9.5-10.7-14.3-4.7-4.7-10.2-8.8-14.2-10.7-1.7-.8-2.9-1.1-3.5-1.1zM71.69 340l-22.77 22.7 60.28 40.2 40.1 60.2 22.8-22.8-9.8-49.2-14.3-14.2-27.6 27.6-12.8-12.8 27.6-27.6-14.3-14.3-49.21-9.8z",
                      fill: "#fff",
                      fillOpacity: "1"
                    })));
}

var Airplane = {
  make: Icon$Airplane
};

function Icon$DragHandle(Props) {
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("svg", {
              className: className,
              fill: "none",
              viewBox: "0 0 6 25",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M.411.829h1.651v2.029H.411zM.411 3.872h1.651v2.029H.411zM.411 6.915h1.651v2.029H.411zM.411 9.957h1.651v2.029H.411zM.411 13h1.651v2.029H.411zM.411 16.043h1.651v2.029H.411zM.411 19.085h1.651v2.029H.411zM.411 22.128h1.651v2.029H.411zM3.714.829h1.651v2.029H3.714zM3.714 3.872h1.651v2.029H3.714zM3.714 6.915h1.651v2.029H3.714zM3.714 9.957h1.651v2.029H3.714zM3.714 13h1.651v2.029H3.714zM3.714 16.043h1.651v2.029H3.714zM3.714 19.085h1.651v2.029H3.714zM3.714 22.128h1.651v2.029H3.714z",
                  fill: "#C4C4C4"
                }));
}

var DragHandle = {
  make: Icon$DragHandle
};

function Icon$NavToggleSwitch(Props) {
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("svg", {
              className: className,
              fill: "none",
              viewBox: "0 0 17 12",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M15.801 11.4a1 1 0 01-1-1V1.6a1 1 0 011-1h.1a1 1 0 011 1v8.8a1 1 0 01-1 1h-.1zm-11.5-6.3l1.74-1.49a1 1 0 000-1.52l-.038-.032a1 1 0 00-1.302 0L.988 5.24a1 1 0 000 1.518L4.7 9.942a1 1 0 001.302 0l.038-.033a1 1 0 000-1.518L4.302 6.9h7.5a.9.9 0 000-1.8H4.301z"
                }));
}

var NavToggleSwitch = {
  make: Icon$NavToggleSwitch
};

function Icon$FrameioLogo(Props) {
  var widthOpt = Props.width;
  var colorOpt = Props.color;
  var width = widthOpt !== undefined ? widthOpt : "";
  var color = colorOpt !== undefined ? colorOpt : "";
  return React.createElement("svg", {
              height: "30",
              width: width,
              fill: "none",
              viewBox: "0 0 10 10",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  clipRule: "evenodd",
                  d: "M0.439894 0.0124292C0.37074 0.0127329 0.300732 0.0291537 0.235412 0.0634271C0.0195389 0.176638 -0.0628016 0.441627 0.0514981 0.655358C0.779792 2.01755 1.14374 3.51189 1.1435 5.0062C1.14374 6.50052 0.779792 7.99488 0.0514981 9.35703C-0.0628016 9.57078 0.0195389 9.83581 0.235412 9.94896C0.300885 9.98332 0.371178 9.99976 0.440485 10H0.443333C0.601376 9.99955 0.75401 9.91492 0.833152 9.76686C1.62931 8.27779 2.02754 6.64436 2.02804 5.01085H2.02811C2.02811 5.00928 2.02809 5.00774 2.02809 5.0062C2.02809 5.00466 2.02811 5.0031 2.02811 5.00156H2.02804C2.02754 3.36803 1.62931 1.7346 0.833152 0.245553C0.754141 0.0977655 0.601815 0.0131885 0.444056 0.0124292H0.439894ZM2.76724 1.09685C2.54158 1.18944 2.43444 1.4456 2.52789 1.66902C2.9721 2.73098 3.19752 3.85219 3.19794 5.00156H3.19792C3.19792 5.0031 3.19794 5.00466 3.19796 5.0062C3.19794 5.00774 3.19792 5.00928 3.19792 5.01085H3.19794C3.19752 6.16022 2.9721 7.28145 2.52789 8.34338C2.43444 8.56683 2.54158 8.823 2.76724 8.91558C2.99286 9.00801 3.25158 8.902 3.34505 8.67855C3.83432 7.50883 4.08241 6.27377 4.08241 5.00766C4.08241 5.00716 4.08239 5.0067 4.08239 5.0062C4.08239 5.00573 4.08241 5.00523 4.08241 5.00477C4.08241 3.73866 3.83432 2.50356 3.34505 1.33388C3.27452 1.16521 3.10979 1.06345 2.93624 1.06345C2.87988 1.06345 2.82258 1.07419 2.76724 1.09685ZM5.25667 2.30178C5.01915 2.35824 4.87285 2.59466 4.92989 2.82985C5.1025 3.54174 5.18865 4.27397 5.18854 5.0062C5.18865 5.73844 5.1025 6.47067 4.92989 7.18258C4.87285 7.41777 5.01915 7.65419 5.25667 7.71063C5.49414 7.76709 5.73286 7.62221 5.78988 7.38703C5.97835 6.60978 6.07258 5.8103 6.07284 5.01085H6.07291C6.07291 5.00928 6.07289 5.00774 6.07289 5.0062C6.07289 5.00466 6.07291 5.0031 6.07291 5.00156H6.07284C6.07258 4.20208 5.97835 3.40265 5.78988 2.62538C5.7412 2.42458 5.56001 2.28959 5.36028 2.28957C5.32609 2.28957 5.29139 2.29351 5.25667 2.30178ZM7.36438 3.57994C7.13549 3.62278 6.97695 3.85577 7.01101 4.08397C7.05651 4.3887 7.07775 4.69527 7.07506 5.00156C7.07506 5.0031 7.07504 5.00466 7.07506 5.0062C7.07504 5.00774 7.07506 5.00928 7.07506 5.01085C7.07775 5.31718 7.05651 5.62373 7.01101 5.92844C6.97614 6.16217 7.12993 6.38859 7.36438 6.43247C7.61236 6.47892 7.84743 6.31187 7.8844 6.06701C7.9373 5.71627 7.96232 5.36343 7.95964 5.01085C7.95967 5.00928 7.95962 5.00774 7.95964 5.0062C7.95962 5.00466 7.95967 5.0031 7.95964 5.00156C7.96232 4.64898 7.9373 4.29614 7.8844 3.94542C7.85161 3.72816 7.66285 3.57219 7.44753 3.57217C7.42015 3.57217 7.39235 3.57471 7.36438 3.57994ZM8.82767 5.01085C8.82767 5.28638 9.05325 5.50976 9.33148 5.50976C9.60972 5.50976 9.83529 5.28638 9.83529 5.01085C9.83529 4.73529 9.60972 4.51193 9.33148 4.51193C9.05325 4.51193 8.82767 4.73529 8.82767 5.01085Z",
                  fill: color,
                  fillRule: "evenodd"
                }));
}

var FrameioLogo = {
  make: Icon$FrameioLogo
};

var slackSvgStyle = Curry._1(Css.style, {
      hd: Css.height(Css.px(16)),
      tl: {
        hd: Css.width(Css.px(16)),
        tl: {
          hd: Css.marginRight(Css.px(12)),
          tl: /* [] */0
        }
      }
    });

var Styles = {
  slackSvgStyle: slackSvgStyle
};

function Icon$AddToSlack(Props) {
  return React.createElement("svg", {
              className: slackSvgStyle,
              viewBox: "0 0 122.8 122.8",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z",
                  fill: "#e01e5a"
                }), React.createElement("path", {
                  d: "M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z",
                  fill: "#36c5f0"
                }), React.createElement("path", {
                  d: "M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z",
                  fill: "#2eb67d"
                }), React.createElement("path", {
                  d: "M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z",
                  fill: "#ecb22e"
                }));
}

var AddToSlack = {
  Styles: Styles,
  make: Icon$AddToSlack
};

var main = Curry._1(Css.merge, {
      hd: "loader",
      tl: {
        hd: Curry._1(Css.style, {
              hd: Css.display("inlineBlock"),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

var Styles$1 = {
  main: main
};

function Icon$Spinner(Props) {
  return React.createElement("span", {
              className: main
            });
}

var Spinner = {
  Styles: Styles$1,
  make: Icon$Spinner
};

function Icon(Props) {
  var classNameOpt = Props.className;
  var marginOpt = Props.margin;
  var classesOpt = Props.classes;
  var icon = Props.icon;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var margin = marginOpt !== undefined ? marginOpt : "";
  var classes = classesOpt !== undefined ? classesOpt : "";
  var iconClass;
  switch (icon) {
    case /* ArrowLeft */0 :
        iconClass = "fa-arrow-left";
        break;
    case /* ArrowRight */1 :
        iconClass = "fa-arrow-right";
        break;
    case /* Copy */2 :
        iconClass = "fa-copy";
        break;
    case /* Share */3 :
        iconClass = "fa-share-alt";
        break;
    case /* Remove */4 :
        iconClass = "fa-times";
        break;
    case /* ArrowUp */5 :
        iconClass = "fa-angle-up";
        break;
    case /* ArrowDown */6 :
        iconClass = "fa-angle-down";
        break;
    case /* Clipboard */7 :
        iconClass = "fa-clipboard";
        break;
    
  }
  return React.createElement("span", {
              className: Curry._1(Css.merge, {
                    hd: "icon is-small",
                    tl: {
                      hd: margin,
                      tl: {
                        hd: classes,
                        tl: /* [] */0
                      }
                    }
                  })
            }, React.createElement("i", {
                  "aria-hidden": true,
                  className: Curry._1(Css.merge, {
                        hd: "fa",
                        tl: {
                          hd: iconClass,
                          tl: {
                            hd: className,
                            tl: /* [] */0
                          }
                        }
                      })
                }));
}

var make = Icon;

export {
  Loop ,
  Goose ,
  Airplane ,
  DragHandle ,
  NavToggleSwitch ,
  FrameioLogo ,
  AddToSlack ,
  Spinner ,
  make ,
  
}
/* slackSvgStyle Not a pure module */
